import { useMemo } from 'react';
import { BoxGeometry } from 'three';
import { SCALE_IN_TO_UNIT } from '../types';
import { MATERIALS } from '../materials';

interface Props {
  /** World position of base center — scene units */
  position: [number, number, number];
  /** Rotation around Y (for L90/U180 arm orientation) — radians */
  rotationY: number;
  /** Width of transition plate matching ramp width — inches */
  widthIn: number;
  refId: string;
  partNumber?: string;
}

const BEVEL_LENGTH_IN = 10;
const BEVEL_ANGLE_DEG = 8;
const PLATE_THICKNESS_IN = 0.25;

/**
 * Transition sol (F05001) — sloped plate at ramp base bridging ramp surface to ground level.
 * Thin aluminium plate, ~10" long, tilted at 8° (matches typical Go Rampe transition).
 */
export function Transition({ position, rotationY, widthIn, refId, partNumber = 'F05001' }: Props) {
  const geometry = useMemo(() => {
    const g = new BoxGeometry(
      widthIn * SCALE_IN_TO_UNIT,
      PLATE_THICKNESS_IN * SCALE_IN_TO_UNIT,
      BEVEL_LENGTH_IN * SCALE_IN_TO_UNIT,
    );
    // FIX: translate down by half-thickness so the TOP of the plate is at y=0 local
    // (= position.y in world). Avant la plate était centrée → moitié sous le sol.
    g.translate(0, -(PLATE_THICKNESS_IN / 2) * SCALE_IN_TO_UNIT, 0);
    return g;
  }, [widthIn]);
  const tiltRad = (BEVEL_ANGLE_DEG * Math.PI) / 180;
  return (
    <mesh
      geometry={geometry}
      material={MATERIALS.aluminumBrushed}
      position={position}
      rotation={[tiltRad, rotationY, 0]}
      castShadow
      receiveShadow
      userData={{ partNumber, kind: 'transition', refId, widthIn }}
    />
  );
}
